import type { ReactElement } from 'react';

import Layout from '@/components/Landing/Layout';
import ClientPage from '@/components/OurSuccessStories/ClientPage';
import Text from '@/components/Text';

const Pulsar = () => {
  return (
    <ClientPage
      companyName="Pulsar"
      clientId="pulsar"
      description={
        <>
          <Text variant="body" className="text-jb-neutral-100">
            Pulsar is a Massively Multiplayer Online (MMO) Real-Time Strategy
            (RTS) game that allows players across the world to mine, build, and
            fight in a real-time battle to become the ruler in the Pulsar
            Universe.
          </Text>
          <Text variant="body" className="text-jb-neutral-100">
            Built on cutting-edge technology, Pulsar delivers breathtaking
            visuals with dynamic lighting, particle effects, and massive-scale
            battles featuring thousands of units simultaneously.
          </Text>
        </>
      }
      topImage="/clients/pulsar/pulsar-top.webm"
      bottomImage="/clients/pulsar/pay-as-you-want.webm"
      scope={
        <>
          <Text variant="body" className="text-jb-neutral-400">
            Development of a large-scale online multiplayer RTS game, including
            world design, gameplay mechanics, server infrastructure, and
            real-time rendering for massive battles with thousands of units.
          </Text>
          <Text variant="body" className="text-jb-neutral-400">
            Additional scope areas covered UI/UX design for complex player
            interactions, matchmaking systems, progression mechanics, and
            in-game economy balancing.
          </Text>
        </>
      }
      industry="Gaming / MMO (RTS)"
      country="USA"
    />
  );
};

Pulsar.getLayout = (page: ReactElement) => <Layout theme="dark">{page}</Layout>;

export default Pulsar;
